import {
  Wallet, Clock, TrendingUp, Scale, Shield, AlertTriangle, HeartPulse,
  MapPin, Users, Coins, Sparkles, Feather, Sprout, Sofa, Heart, Compass,
} from "lucide-react";

export const FACTOR_ICONS = {
  income: Wallet,
  time: Clock,
  career: TrendingUp,
  balance: Scale,
  stability: Shield,
  risk: AlertTriangle,
  health: HeartPulse,
  location: MapPin,
  family: Users,
  cost: Coins,
  quality: Sparkles,
  freedom: Feather,
  growth: Sprout,
  comfort: Sofa,
  relationship: Heart,
  other: Compass,
};

export function FactorIcon({ name, className }) {
  const Icon = FACTOR_ICONS[name] || Compass;
  return <Icon className={className} strokeWidth={1.6} />;
}
